import TimeZoneSelect from "./TimeZoneSelect"
import WeightUnitsSelect from "./WeightUnitsSelect"
import '../styles/Settings.css'

const Settings = ({ onWeightUnitClick, activeWeightUnit }) => {
  return (
    <div className='settings'>
      <div style={{fontSize: '38px', textDecoration: 'underline'}}>Settings</div>
      <div className='settingsContainer'>
        <WeightUnitsSelect onClick={onWeightUnitClick} activeWeightUnit={activeWeightUnit}/>
        <TimeZoneSelect/>
      </div>
    </div>
  )
}

export default Settings